import React, { useContext, useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Headerbar from "./Headerbar";
import { UserContext } from "../../context/UserContext";
import LogoutConfirmation from "../LogoutModal";
import Footer from "./Footer";
import MobileNavBar from "./MobileNavBar";

const Layout = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [isMobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const { user, contextLogout, roles } = useContext(UserContext);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  // Adjust layout responsiveness based on screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640);
      if (window.innerWidth >= 640) {
        setMobileSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    contextLogout();
    setShowLogoutModal(false);
  };

  return (
    <div className="flex h-screen bg-bodyMain">

      {/* ✅ Mobile Sidebar Toggle Button (Appears only on small screens) */}
      {roles.includes('admin') && (
        <>
          {(isMobile && !isMobileSidebarOpen) && (
            <button
              className="fixed top-3 left-4 z-30 p-2 bg-primary text-white rounded-full shadow-lg sm:hidden"
              onClick={() => setMobileSidebarOpen(true)}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
              </svg>
            </button>
          )}
        </>
      )}



      {/* ✅ Sidebar for larger screens */}
      <div className={`hidden sm:block transition-all duration-300 ${isSidebarOpen ? "w-64" : "w-16"}`}>
        <Sidebar
          isOpen={isSidebarOpen}
          toggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
          user={user}
          roles={roles}
          setShowLogoutModal={setShowLogoutModal}
        />
      </div>


      {roles.includes('admin') && (
        <>
          {/* ✅ Mobile Sidebar (Slide-in Drawer) */}
          {isMobileSidebarOpen && (
            <div className="fixed inset-0 backdrop-blur-sm z-40 sm:hidden" onClick={() => setMobileSidebarOpen(false)}>
              <div className="w-64 h-full" onClick={(e) => e.stopPropagation()}>
                <Sidebar
                  isOpen={true}
                  toggleSidebar={() => setMobileSidebarOpen(false)}
                  user={user}
                  roles={roles}
                  setShowLogoutModal={setShowLogoutModal}
                />
              </div>
            </div>
          )}
        </>
      )}


      {/* ✅ Main Content Area */}
      <div className="flex-grow flex flex-col overflow-hidden">

        {/* ✅ Header */}
        <Headerbar
          user={user}
          roles={roles}
          setShowLogoutModal={setShowLogoutModal}
          isSidebarOpen={isSidebarOpen}
        />

        {/* ✅ Page Content (Responsive Spacing) */}
        <div className="flex-grow px-2 sm:px-12 h-full overflow-y-auto  pt-24 pb-24 sm:pt-28 sm:pb-24">
          {children}
        </div>

        {/* ✅ Footer (Adapts to screen size) */}
        <Footer roles={roles} isSidebarOpen={isSidebarOpen} />
        {roles.includes('user') && (
          <MobileNavBar />
        )}
      </div>

      {/* ✅ Logout Confirmation Modal */}
      <LogoutConfirmation
        isOpen={showLogoutModal}
        onConfirm={handleLogout}
        onClose={() => setShowLogoutModal(false)}
      />
    </div>
  );
};

export default Layout;
